import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=38a4d94c&scoped=true&lang=pug&"
import script from "./MaterialForm.vue?vue&type=script&lang=js&"
export * from "./MaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&id=38a4d94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4d94c",
  null
  
)

export default component.exports